"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Numeric {
    /**
     * Equal function between two numbers
     */
    static numericEqual(d1, d2, error = Numeric.Epsilon) {
        if (Number.isNaN(d1) && Number.isNaN(d2))
            return true;
        return Math.abs(d1 - d2) < error;
    }
    static middle(value1, value2) {
        return (value1 + value2) / 2.0;
    }
}
exports.default = Numeric;
Numeric.Epsilon = 0.00001;
//# sourceMappingURL=Numeric.js.map